import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextInput from '../../../../../../../components/ZUILib/TextInput';
import CheckBox from '../../../../../../../components/ZUILib/CheckBox';
import InputButton from '../../../../../../../components/ZUILib/InputButton';
import commonUtil from '../../../../../../../utils/commonUtil';
import { constEventStatus, eventType } from '../../../../../../../utils/clientConstant';
const errorObject = require('../../../../../../../utils/errors/LP_GR_error.json');
const channel = commonUtil.getChannel();
class Celebrate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Initialize your state here if needed
            title: props.celebrityData?.title || '',
            celebrityData: props.celebrityData,
            initialcelebrityData: props.celebrityData || {},
            disableSubmit: true,
            disableCancel: true,
            initialcelebrityDataPhone: props.celebrityData?.phone || '',
            initialcelebrityDataEmail: props.celebrityData?.email || '',
            enableCheckBox: props.celebrityData?.hasPermission || false,
            enableCreateForm: false,
            enableCreateCheckbox: false,
            disableCreateSubmit: true,
            hidetheSubmitButton : true,
            isSubmited: false,
            canAddCelebrity: 'false',
        };
    }

    componentDidMount() {
        this.setState({
            celebrityData: this.props.celebrityData,
            title: this.props.celebrityData?.title || '',
            initialcelebrityData: this.props.celebrityData,
            initialcelebrityDataPhone: this.props.celebrityData?.phone || '',
            initialcelebrityDataEmail: this.props.celebrityData?.email || '',
            enableCheckBox: this.props.celebrityData?.hasPermission || false
        });
          if(channel === 'wap') {
           document.addEventListener('click', this.handleClickOutside);
      }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.celebrityData !== this.props.celebrityData) {
            const {celebrityData, EventTypeProps, enableCelebrityUpdate} = this.props;
            const celebrityObj = { ...celebrityData };
            const categoryThree = [eventType?.Mascotas || '', eventType?.Bebe || ''];
            let canAddCelebrity = this.props.canAddCelebrity;
            if(enableCelebrityUpdate && EventTypeProps && categoryThree.includes(EventTypeProps)){
                celebrityObj.firstName = "";
                canAddCelebrity = 'true';
            }

            this.setState({
                celebrityData: celebrityObj,
                title: celebrityObj?.title || '',
                initialcelebrityData: celebrityObj,
                initialcelebrityDataPhone: celebrityObj?.phone || '',
                initialcelebrityDataEmail: celebrityObj?.email || '',
                enableCheckBox: celebrityObj?.hasPermission || false,
                canAddCelebrity: canAddCelebrity
            });
        }
    }

      componentWillUnmount() {
       if (channel === 'wap') {
        document.removeEventListener('click', this.handleClickOutside);
      }
  }


   handleClickOutside = (event) => {
    if (channel === 'wap') {
       const tooltip = document.querySelector('#helpPopupPersonal');
      if (tooltip && !tooltip.contains(event.target) && tooltip.style.display === 'block') {
           tooltip.style.display = 'none';
       }
    }
  }
    checkboxHandler = (data) => {
        // this.checkBoxSelected = data.checked;
        const { initialcelebrityData, celebrityData, enableCreateForm } = this.state
        const currentValue = this.state.enableCheckBox;
        // if(celebrityData && celebrityData?.hasPermission && !data.checked){
        //     //if already hasPermission True you cannot uncheck and make it false
        //     return false
        // }

        this.setState({
            enableCheckBox: !currentValue,
        }, () => {
            const phoneValue = celebrityData.phone ?? '';
            const emailValue = celebrityData.email ?? '';

            const isCheckboxPermissionSameAsInitial = initialcelebrityData && initialcelebrityData.hasPermission === data.checked;

            const disableCancel = (((initialcelebrityData.email ?? '') != emailValue) || ((initialcelebrityData.phone ?? '') != phoneValue)) || !isCheckboxPermissionSameAsInitial ? false : true;
            let disableSubmit = ((initialcelebrityData.email ? true : ((initialcelebrityData.email ?? '') != emailValue)) && ((initialcelebrityData.phone ?? '') != phoneValue)) || !isCheckboxPermissionSameAsInitial ? false : true;

            if(emailValue == "" || phoneValue == ""){
                disableSubmit = true;
            }

            if (initialcelebrityData.hasPermission === this.state.enableCheckBox) {
                 this.setState({
                    disableSubmit: disableSubmit,
                    disableCancel: disableCancel,
                    hidetheSubmitButton: true,
                });
            } else if (initialcelebrityData && ((initialcelebrityData.email ?? '') === '' || (initialcelebrityData.phone ?? '') === '') && data.checked) {
                this.setState({
                    disableSubmit: disableSubmit,
                    disableCancel: disableCancel,
                    hidetheSubmitButton: false
                });
            } else {
                this.setState({
                    disableSubmit: enableCreateForm ? false : disableSubmit,
                    disableCancel: enableCreateForm ? false : disableCancel,
                    hidetheSubmitButton: false
                });
            }
        });
    }
    checkboxHandlerforCreate = (data) => {
        // this.checkBoxSelected = data.checked;
        const currentValue = this.state.enableCreateCheckbox;

        this.setState({
            enableCreateCheckbox: !currentValue,
        });
    }

    disableCreateSubmitfunc = (val) => {
        this.setState({
            disableCreateSubmit: val
        })
    }
    disableSubmitButton = (val) => {
        this.setState({
            disableSubmit: val
        })
    }

    hidetheSubmitButton = (val) => {
        this.setState({
            hidetheSubmitButton: val
        })
    }

    disableCancelButton = (val) => {
        this.setState({
            disableCancel: val
        })
    }


    updatecelebrityData = (e) => {

        const { enableCreateForm, initialcelebrityDataPhone, initialcelebrityDataEmail, celebrityData } = this.state;
        //check wthere edit or create based on enableCreateForm flag

        const { name, value } = e.target;

        if(name === 'email' && value !== celebrityData.email){
            this.props.setCelebrityFormEmailError('');
        }

        this.setState((prevState) => ({
            celebrityData: {
                ...prevState.celebrityData, // Spread previous formData
                [name]: value, // Update only the specific field
            }
        }), () => {
            const phoneHasValue = celebrityData.phone && celebrityData.phone.trim().length > 0;
            const emailHasValue = celebrityData.email && celebrityData.email.trim().length > 0;

            if(((name === 'phone' ? (initialcelebrityDataPhone !== value && value.length > 0) : (initialcelebrityDataPhone !== celebrityData.phone && phoneHasValue)) || (name === 'email' ? (initialcelebrityDataEmail !== value && value.length > 0) : (initialcelebrityDataEmail !== celebrityData.email && emailHasValue)))){
                this.disableCancelButton(false);
            } else {
                this.disableCancelButton(true);
            }

            if (name == 'phone' && initialcelebrityDataPhone != value && value.length > 0 && emailHasValue) {
                this.disableSubmitButton(false)

            }
            else if (name == 'email' && initialcelebrityDataEmail != value && value.length > 0 && phoneHasValue) {
                this.disableSubmitButton(false)
            }
            else {
                this.disableSubmitButton(true)
            }
        });
    }
    resetPartnerForm = () => {
        this.setState({
            enableCheckBox: this.state.initialcelebrityData.hasPermission,
            celebrityData: this.state.initialcelebrityData,
            disableSubmit: true,
            disableCancel: true,
            hidetheSubmitButton: this.state.initialcelebrityData.hasPermission ? false : true,
        })
    }

    //update the value if any changes in  XV_anos event
    validate = () => {
        const { enableCreateForm, celebrityData, enableCheckBox, initialcelebrityData } = this.state;
        let hasPermission = false;
        const phoneNumber = celebrityData?.phone;
        if (enableCheckBox) {
            hasPermission = true;
            let phoneNumberValid = true;
            let emailValid = true;
            if (phoneNumber) {
                const phoneNumberValidationRules = [
                    { functionRef: commonUtil.isValueAvailable, funcData: [this.celebrityPhone.getValue()], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.required.field') },
                    { functionRef: commonUtil.validateNumber, funcData: [this.celebrityPhone.getValue()], errorMessage: commonUtil.getError(errorObject.AddAddress, 'AddAddress.error.phone.invalid.field') },
                ];
                phoneNumberValid = commonUtil.validateTextInput(phoneNumberValidationRules, this.celebrityPhone, null);

                if (initialcelebrityData?.email == "") {
                    const emailValidationRules = [
                        // { functionRef: commonUtil.compareEmail, funcData: [this.partnerEmail.getValue(), this.ownerEmailId], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error') },
                        { functionRef: commonUtil.isValueAvailable, funcData: [this.celebrityEmail.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.email.error.required') },
                        { functionRef: commonUtil.validateEmail, funcData: [this.celebrityEmail.getValue(), 3], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.email.error.invalid') },
                    ];
                    emailValid = commonUtil.validateTextInput(emailValidationRules, this.celebrityEmail, null);
                    if (!emailValid) {
                        return false;
                    }
                }

                if (!phoneNumberValid) {
                    return false
                }
            }

            const payload = {
                "ownerId": celebrityData.repositoryId,
                "ownerTitle": celebrityData.title,
                "ownerHasPermission": hasPermission,
                "ownerfirstName": celebrityData.firstName,
                "ownerlastName": celebrityData.lastName,
                "ownerMotherName": celebrityData.motherName,
                "ownerPhone": celebrityData.phone,
                "ownerEmail": celebrityData.email,
                "isCelebrity": true
            }

            this.props.updatecelebrateDetails(payload,'celebrityForm');
            this.disableSubmitButton(true)
            this.disableCancelButton(true)
            this.hidetheSubmitButton(true)
        }
        else {
            const payload = {
                "ownerId": celebrityData.repositoryId,
                "ownerTitle": celebrityData.title,
                "ownerHasPermission": hasPermission || false,
                "ownerfirstName": celebrityData.firstName,
                "ownerlastName": celebrityData.lastName,
                "ownerMotherName": celebrityData.motherName,
                "ownerPhone": "",
                "ownerEmail": "",
                "isCelebrity": true
            }

            this.props.updatecelebrateDetails(payload,'celebrityForm');
            this.disableSubmitButton(true)
            this.disableCancelButton(true)
            this.hidetheSubmitButton(true)

        }

    }
    createpartnerForm = () => {
        this.setState({
            enableCreateForm: true,
            disableCancel: false,
        })
    }

    onChangeCreateForm = (e) => {
        const { enableCreateForm, initialcelebrityData } = this.state;
        //check wthere edit or create based on enableCreateForm flag

        const { name, value } = e.target;
        this.setState((prevState) => ({
            initialcelebrityData: {
                ...prevState.initialcelebrityData, // Spread previous formData
                [name]: value, // Update only the specific field
            },

        }), () => {
            //
            // if ((name == 'firstName' && value.length > 0) ||
            //     (name == 'lastName' && value.length > 0) ||
            //     (name == 'motherName' && value.length > 0)) {
            //     this.disableCreateSubmitfunc(false);
            // }else{
            //     this.disableCreateSubmitfunc(true);
            // }
            // else{
            //     this.setState({
            //          disableCreateSubmit: true
            //     })
            // }

            const { EventTypeProps } = this.props
            const categoryThree = [eventType?.Mascotas || '', eventType?.Bebe || '']

            const firstNameHasValue = (name == 'firstName') ? value.length > 0 : (initialcelebrityData.firstName && initialcelebrityData.firstName.trim().length > 0);
            const lastNameHasValue = (name == 'lastName') ? value.length > 0 : (initialcelebrityData.lastName && initialcelebrityData.lastName.trim().length > 0);

            const motherNameHasValue = (name == 'motherName') ? value.length > 0 : (initialcelebrityData.motherName && initialcelebrityData.motherName.trim().length > 0);

            if (firstNameHasValue || lastNameHasValue || motherNameHasValue) {
                this.disableCancelButton(false);
            } else {
                this.disableCancelButton(true);
            }

            if(EventTypeProps && categoryThree.includes(EventTypeProps)){
                // Mascotas: firstname mandatory; Bebe: firstname optional
                if (EventTypeProps === eventType?.Mascotas) {
                    if (firstNameHasValue) {
                        this.disableCreateSubmitfunc(false);
                    } else {
                        this.disableCreateSubmitfunc(true);
                    }
                }
                if (EventTypeProps === eventType?.Bebe) {
                    this.disableCreateSubmitfunc(false);
                }
            } else {
                if(firstNameHasValue && lastNameHasValue){
                    this.disableCreateSubmitfunc(false);
                } else {
                    this.disableCreateSubmitfunc(true);
                }
            }
            
        });
    }

    //validates and submits the create scenario for bebe and XV_anos event
    validateCreatForm = () => {

        const { enableCreateForm, initialcelebrityData } = this.state;
        const { EventTypeProps } = this.props
        let firstNameValid = true;
        let lastNameValid = true;
        let motherValidName = true;
        const configurationNumber = Number(commonUtil.getLabel(this.props.lables?.createEventStep1, 'createEventStep1.inputconfiguration.number'))
        if (enableCreateForm) {

            //fisrtname
            const firstNameValidationRules = [
                { functionRef: commonUtil.validateLength, funcData: [this.celebfirstname.getValue(), configurationNumber], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.error.minthreelentgh') },
                { functionRef: commonUtil.isValueAvailable, funcData: [this.celebfirstname.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.firstName.error.required') },
                { functionRef: commonUtil.validateName, funcData: [this.celebfirstname.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

            ];
            firstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.celebfirstname, null);



            if (EventTypeProps === eventType.Open_House
                ||
                EventTypeProps === eventType.Other_Religious_Ceremonies
                ||
                EventTypeProps === eventType.Others
                ||
                EventTypeProps === eventType.Cumpleanos) {

                const lastNameValidationRules = [
                    { functionRef: commonUtil.validateLength, funcData: [this.celeblastname.getValue(), configurationNumber], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.error.minthreelentgh') },
                    { functionRef: commonUtil.isValueAvailable, funcData: [this.celeblastname.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.lastName.error.required') },
                    { functionRef: commonUtil.validateName, funcData: [this.celeblastname.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

                ];
                lastNameValid = commonUtil.validateTextInput(lastNameValidationRules, this.celeblastname, null);



                let motherNameValidation;
                if (this.celebmothername.getValue() && this.celebmothername.getValue().length > 0) {
                    motherNameValidation = [
                        { functionRef: commonUtil.validateLength, funcData: [this.celebmothername.getValue(), configurationNumber], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.error.minthreelentgh') },
                        //{ functionRef: commonUtil.validateName, funcData: [this.celebmothername.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

                    ];
                    motherValidName = commonUtil.validateTextInput(motherNameValidation, this.celebmothername, null);
                }
                else {
                    motherNameValidation = [
                        { functionRef: commonUtil.validatempty, funcData: [this.celebmothername.getValue()] },
                        //{ functionRef: commonUtil.validateName, funcData: [this.celebmothername.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

                    ];
                    motherValidName = commonUtil.validateTextInput(motherNameValidation, this.celebmothername, null);

                }
            }



            if (!firstNameValid || !lastNameValid || !motherValidName) {
                return false
            }

            this.submitCelebrityForm();
            this.isSubmited = true;
        }
    }

    submitCelebrityForm = () => {

        const { EventTypeProps } = this.props;
        const { initialcelebrityData } = this.state;

        const categoryThree = [eventType?.Mascotas || '', eventType?.Bebe || ''];

        if (EventTypeProps == eventType.Bebe ||
            EventTypeProps === eventType.Open_House
            ||
            EventTypeProps === eventType.Other_Religious_Ceremonies
            ||
            EventTypeProps === eventType.Others
            ||
            EventTypeProps === eventType.Cumpleanos
            ||
            (this.props.enableCelebrityUpdate && EventTypeProps && categoryThree.includes(EventTypeProps))
        ) {
            const payload = {
                "ownerTitle": '',
                "ownerHasPermission": false,
                "ownerfirstName": initialcelebrityData.firstName,
                "ownerlastName": initialcelebrityData?.lastName || '',
                "ownerMotherName": initialcelebrityData?.motherName || '',
                "ownerPhone": '',
                "ownerEmail": '',
                "isCelebrity": true,
                ...(this.props.enableCelebrityUpdate && {"celebrityUpdated": true}),
            }
            this.props.createcelebrateDetails(payload)
            this.disableCreateSubmitfunc(true);
        }
    }

    resetCreateform = () => {
        this.setState({
            initialcelebrityData: {},
            enableCreateForm: false,
            disableCreateSubmit: true,
            disableCancel: true,
        })
    }

    resetFormForEnableCelebrityUpdate = () => {
        this.setState(prev => ({
            initialcelebrityData: { ...prev.initialcelebrityData, firstName: "" },
            celebrityData: { ...prev.celebrityData, firstName: "" },
            disableCreateSubmit: true,
            disableCancel: true
        }), () => {
            this.celebfirstname?.setValue('');
        });
    }

    handlePopUpCoOwner = (e, id) => {
      if(channel === 'wap'){
        e.stopPropagation();
        const data = document.querySelector('#' + id);
        if (data.style.display === 'block') {
            data.style.display = 'none';
        } else {
            data.style.display = 'block';
        }
      }
    }


    render() {
        const { celebrate1FirstName, celebrate2FirstName, EventTypeProps,lables,ownerIsCelebrity, eventStatus } = this.props
        const { enableCheckBox, disableSubmit, enableCreateForm, celebrityData, enableCreateCheckbox, disableCreateSubmit,
            initialcelebrityData, title, disableCancel, hidetheSubmitButton,
        } = this.state;

        const categoryOne = [eventType?.Other_Religious_Ceremonies || '', eventType?.Open_House || '', eventType?.Others || '', eventType?.Cumpleanos || '', eventType?.Baptism || '']
        const categorytwo = [eventType?.XV_Anos || '']
        const categoryThree = [eventType?.Mascotas || '', eventType?.Bebe || '']
        const isTemporaryClosed = eventStatus && ((eventStatus === constEventStatus.TEMPORARYCLOSED) || (eventStatus === constEventStatus.SUSPENDED) || (eventStatus === constEventStatus.CLOSED));
        let createcancelButton = {
            className: 'personal-data-cancel-button',
            name: 'Cancelar',
            type: 'button',
            value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.cancel.data'),
            disabled: disableCancel,
            autoFocus: false,
            style: 'personal-data-cancel-button',
            onClickHandler: () => {
                this.resetCreateform();
            },
            cssStyle: !disableCancel ? { border: `2px solid ${this.props.selectedTheme?.color_500}`, color: this.props.selectedTheme?.color_500 } : ""
        };

        let createactualizarDatos = {
            id: 'updateData',
            type: 'button',
            name: 'Guardar cambios',
            value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.save.changes'),
            classname: 'personal-data-button',
            onClickHandler: () => {
                // Handle clear filter action
                this.validateCreatForm()

            },
            disabled: disableCreateSubmit,
            autoFocus: false,
            ariaLabel: 'update personal data',
            ariaHidden: false,
            cssStyle: !disableCreateSubmit ? { backgroundColor: this.props.selectedTheme?.color_500, color: "#fff" } : ""
        }
        let createAdministator = {
            disabled: isTemporaryClosed,
            className: 'celebrity-data-create-admin-button',
            name: 'Agregar festejado',
            type: 'button',
            value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.create.celebrity'),
            autoFocus: false,
            style: 'celebrity-data-create-admin-button',
            onClickHandler: () => {
                this.createpartnerForm();
            },
            cssStyle : isTemporaryClosed ? { border: `2px solid #d8d8d8`,color : "#d8d8d8" } : { border: `2px solid ${this.props.selectedTheme?.color_500 }`,color : this.props.selectedTheme?.color_500 }
        };
        let actualizarDatos = {
            id: 'updateData',
            type: 'button',
            name: 'Actualizar datos',
            // value: 'Actualizar datos',
            value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.save.changes'),
            classname: 'personal-data-button',
            onClickHandler: () => {
                // Handle clear filter action
                this.validate()

            },
            disabled: disableSubmit,
            autoFocus: false,
            ariaLabel: 'update personal data',
            ariaHidden: false,
            cssStyle: !disableSubmit ? { backgroundColor: this.props.selectedTheme?.color_500, color: "#fff" } : ""
        };

        let cancelButton = {
            className: 'personal-data-cancel-button',
            name: 'Cancelar',
            type: 'button',
            value: commonUtil.getLabel(lables.EventAdminPage,'adminpage.button.cancel.data'),
            disabled: disableCancel || isTemporaryClosed,
            autoFocus: false,
            style: 'personal-data-cancel-button',
            onClickHandler: () => {
                this.resetPartnerForm();
            },
            cssStyle: !disableCancel && !isTemporaryClosed ? { border: `2px solid ${this.props.selectedTheme?.color_500}`, color: this.props.selectedTheme?.color_500 } : ""
        };
        return (

            <div>
                {
                    <div className='personal-data-celebrated-section'>
                        {ownerIsCelebrity ?
                            <div className='personal-data-partner-section'  >
                                <div className='celebrity-data-no-participant-lable'>
                                    {commonUtil.getLabel(lables.EventAdminPage, 'adminpage.personaldata.owner.is.celebrity')}
                                </div>                                
                            </div>                                                   
                        :
                            <React.Fragment>
                                {
                                    (EventTypeProps === eventType.Open_House
                                        ||
                                        EventTypeProps === eventType.Other_Religious_Ceremonies
                                        ||
                                        EventTypeProps === eventType.Others
                                        ||
                                        EventTypeProps === eventType.Cumpleanos
                                        ||
                                        EventTypeProps === eventType.XV_Anos
                                    ) &&
                                    <div className='required-field-lable'>
                                            {EventTypeProps === eventType.XV_Anos && enableCheckBox && "*Campos obligatorios"}
                                    </div>
                                }                        
                                {(celebrityData && Object.keys(celebrityData).length > 0 && celebrityData?.firstName) || enableCreateForm ?
                                    <>
                                        <div className='personal-data-title'>                                    
                                            {commonUtil.getLabel(lables.EventAdminPage,'adminpage.celebrant.lable')}
                                        </div>
                                        {/* create form */}
                                        {enableCreateForm ?
                                            <>
                                                <TextInput
                                                    className="inputMaterial"
                                                    labelClassName="placeHolderMaterial"
                                                    htmlId="CelebFirstname"
                                                    label="Nombre"
                                                    name="firstName"
                                                    required="true"
                                                    {...(EventTypeProps === eventType.Bebe ? {} : { star: "*" })}
                                                    value={celebrityData?.firstName || ''}
                                                    disabled={celebrityData?.firstName ? true : ''}
                                                    onChange={(e) => { this.onChangeCreateForm(e) }}
                                                    ref={el => (this.celebfirstname = el)}
                                                    maxlength="100"
                                                />

                                                {(EventTypeProps === eventType.Open_House
                                                    ||
                                                    EventTypeProps === eventType.Other_Religious_Ceremonies
                                                    ||
                                                    EventTypeProps === eventType.Others
                                                    ||
                                                    EventTypeProps === eventType.Cumpleanos
                                                )

                                                    &&
                                                    <>
                                                        <TextInput
                                                            className="inputMaterial"
                                                            labelClassName="placeHolderMaterial"
                                                            htmlId="partnerSecondSurname"
                                                            label="Primer apellido"
                                                            name="lastName"
                                                            required="true"
                                                            star="*"
                                                            value={celebrityData?.lastName || ''}
                                                            disabled={celebrityData?.lastName ? true : ''}
                                                            onChange={(e) => { this.onChangeCreateForm(e) }}
                                                            ref={el => (this.celeblastname = el)}
                                                            maxlength="100"
                                                        />

                                                        <TextInput
                                                            className={`inputMaterial ${celebrityData?.motherName ? '' : 'lastnameInput'}`}
                                                            labelClassName="placeHolderMaterial"
                                                            htmlId="partnerFirstSurname"
                                                            label="Segundo apellido"
                                                            name="motherName"
                                                            required="false"
                                                            maxlength="100"
                                                            // star="*"
                                                            value={celebrityData?.motherName || ''}
                                                            disabled={celebrityData?.motherName ? true : ''}
                                                            onChange={(e) => { this.onChangeCreateForm(e) }}
                                                            ref={el => (this.celebmothername = el)}
                                                        />
                                                    </>
                                                }


                                                {!this.isSubmited &&
                                                    <div className="personal-data-button-wrapper">
                                                        <InputButton buttonAttr={createcancelButton} />
                                                        <InputButton buttonAttr={createactualizarDatos} />

                                                    </div>
                                                }

                                            </>
                                            :
                                            //only display here and edit the phone number for XV_ANos
                                            <>
                                                {EventTypeProps && categoryThree.includes(EventTypeProps) ? <TextInput
                                                    className="inputMaterial"
                                                    labelClassName="placeHolderMaterial"
                                                    htmlId="name"
                                                    label="Nombre"
                                                    name="Nombre"
                                                    required="true"
                                                    {...(EventTypeProps === eventType.Bebe ? {} : { star: "*" })}
                                                    value={celebrityData.firstName || ''}
                                                    disabled={true}
                                                /> :
                                                    <TextInput
                                                        className="inputMaterial"
                                                        labelClassName="placeHolderMaterial"
                                                        htmlId="name"
                                                        label="Nombre"
                                                        name="Nombre"
                                                        required="true"
                                                        star="*"
                                                        value={celebrityData.firstName || ''}
                                                        disabled={true}
                                                    />
                                                }

                                                {EventTypeProps && (categoryOne.includes(EventTypeProps) || (categorytwo.includes(EventTypeProps))) &&
                                                    <>
                                                        <TextInput
                                                            className="inputMaterial"
                                                            labelClassName="placeHolderMaterial"
                                                            htmlId="firstSurname"
                                                            label="Primer apellido"
                                                            name="Primer apellido"
                                                            required="true"
                                                            star="*"
                                                            value={celebrityData.lastName || ''}
                                                            disabled={true}                                                    
                                                        // onChange={() => { }}
                                                        />
                                                        <TextInput
                                                            className={`inputMaterial ${celebrityData?.motherName ? '' : 'lastnameInput'}`}
                                                            labelClassName="placeHolderMaterial"
                                                            htmlId="lastname"
                                                            label="Segundo apellido"
                                                            name="Segundo apellido"
                                                            value={celebrityData.motherName || ''}
                                                            disabled={true}
                                                        // onChange={() => { }}

                                                        />
                                                    </>
                                                }

                                                {EventTypeProps && categorytwo.includes(EventTypeProps) &&
                                                    <>
                                                        <div className='personal-data-checkbox-section personal-data-xv-anos-checkbox'>
                                                            <CheckBox
                                                                htmlId={'_showEmail'}
                                                                displayName={<span className='gapLabelWap'>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.personal.checkbox.label')}</span>}
                                                                getSelectedValue={this.checkboxHandler}
                                                                checked={this.state.enableCheckBox}
                                                                ref={el => (this.CheckBox = el)}
                                                                customCss={true}
                                                                disabled={isTemporaryClosed}
                                                                isSuspended={isTemporaryClosed}
                                                            />
                                                            <div className="iconHelp inLine iconHelp-pl iconHelpWrapper">
                                                                <img src={commonUtil.getAssetURL() + '/images/help.svg'} alt="icon_help" className="icon_help" onClick={(e) => { this.handlePopUpCoOwner(e ,'helpPopupPersonal'); }} />
                                                                <div className="tooltip-backdrop" />
                                                                <div id="helpPopupPersonal" className="popover bottom helpIconCssEmail helpIconEventCss">
                                                                    <div className="arrow" />
                                                                    <div className="popover-content">
                                                                         {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.celebritypopoverContent.label')}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {enableCheckBox &&
                                                            <>
                                                                <TextInput
                                                                    className="inputMaterial"
                                                                    labelClassName="placeHolderMaterial"
                                                                    htmlId="celebratephone"
                                                                    label="Celular"
                                                                    required="true"
                                                                    star="*"
                                                                    name="phone"
                                                                    maxlength="10"
                                                                    onChange={(e) => { this.updatecelebrityData(e) }}
                                                                    value={celebrityData && celebrityData?.phone || ''}
                                                                    ref={el => (this.celebrityPhone = el)}
                                                                    onKeyDown={(e) => { commonUtil.handleAllowOnlyDigit(e); }}
                                                                    {...isTemporaryClosed || this.state.initialcelebrityDataPhone ? { disabled: true } : {}}
                                                                />
                                                                <TextInput
                                                                    className="inputMaterial"
                                                                    labelClassName="placeHolderMaterial"
                                                                    htmlId="email"
                                                                    label="Correo electrónico"
                                                                    required="true"
                                                                    star="*"
                                                                    maxlength="100"
                                                                    onChange={(e) => { this.updatecelebrityData(e) }}
                                                                    name="email"
                                                                    parentClassName={''}
                                                                    disabled={(initialcelebrityData && initialcelebrityData?.email) ? true : false}
                                                                    ref={el => (this.celebrityEmail = el)}
                                                                    value={celebrityData && celebrityData?.email || ''}

                                                                />

                                                                { this.props.celebrityFormEmailError && <span className="input-error-message" id="emailError">{this.props.celebrityFormEmailError}</span>}
                                                            </>}
                                                        <div className="personal-data-button-wrapper">
                                                            {(!hidetheSubmitButton || enableCheckBox) && 
                                                            <>
                                                            <InputButton buttonAttr={cancelButton} />
                                                            <InputButton buttonAttr={actualizarDatos} />
                                                            </>
                                                            }
                                                        </div>
                                                    </>
                                                }
                                            </>}
                                    </>
                                    :
                                    <div className='personal-data-partner-section'  >
                                        <div className='celebrity-data-no-participant-lable'>                                    
                                            {this.state.canAddCelebrity === 'true' ? commonUtil.getLabel(lables.EventAdminPage,'adminpage.message.no.participant') : commonUtil.getLabel(lables.EventAdminPage,'adminpage.message.cant.addParticipant')}
                                        </div>
                                        {
                                            this.state.canAddCelebrity === 'true' && <InputButton buttonAttr={createAdministator} />
                                        }
                                    </div>
                                }

                            </React.Fragment>
                        } 
                    </div>


                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    labels: state.labels.data
}

export default connect(mapStateToProps)(Celebrate);
